module.exports = __webpack_public_path__ + "saved_list.png";